import Select from "./Select";
import React, { PureComponent } from "react";

class SelectMulti extends PureComponent {
  render = () => <Select {...this.props} multi />;
}

export default SelectMulti;
